module.exports = __webpack_public_path__ + "media/LACHSONG_TORSTEN.f8aa25fd.mp3";